export default __webpack_public_path__ + "static/media/italiaoggi.d93e8c2e.png";